import styled from 'styled-components';

const ChatStepContainer = styled.div`
  background: #f5f5f5;
  border-radius: 5px;
  box-shadow: none;
  display: flex;
  justify-content: center;
  margin: 0 6px 10px 6px;
  padding: 0;
`;

export default ChatStepContainer;
